import { ReactNode, useCallback, useEffect, useState } from 'react';
import { Button, Dropdown, MenuProps, message, Modal, Space, Table, Tooltip } from 'antd';
import {
  buildInQuery,
  IItemsWithCount,
  ILeadEntity,
  IProcurementEntity, IUserEntity,
  KeyValueRecord,
  LeadCreditStatusEnum,
} from '@rasayi-workspace/shared';
import { DEFAULT_TABLE_STATE } from '@constants';
import { ITableFilters, ITableState } from '@interfaces';
import { ColumnsType } from 'antd/es/table';
import { EMPTY_INITIAL_ITEMS, GetTableItems } from '@services';
import TextTypography from 'src/app/components/shared/Typography/Text';
import { TableProps } from 'antd/lib';
import { MapAntDesignSearchFilter, MapAntDesignSortOrder, RemoveUndefinedKeyPairs } from '@helpers';
import { SorterResult } from 'antd/es/table/interface';
import MoreIcon from 'src/assets/icons/moreIcon';
import {
  CheckSquareOutlined,
  DislikeOutlined,
  EyeOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { debounce } from 'lodash';
import RejectIcon from 'src/assets/icons/rejectIcon';
import { useLeadContext } from '@contexts';
import { HoldModal } from '../../../shared/modals/holdModal';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { BASE_QUERY_OPTIONS } from '@constants';
import { ViewPlanModal } from '../../../shared/modals/ViewPlanModal';
import FilterAction from '../../../shared/FilterAction/FilterAction';
import ProcurementDetailsModal from '../procurements/Manage_Procurement/ProcurementDetails';
import { PutItem } from '../../../../services';
import TextArea from 'antd/es/input/TextArea';

interface IFilterItemProps {
  children: ReactNode;
  item: IProcurementEntity;
}
interface ICreditLeadsProps {
  showRepeated?: boolean;
  activeTab: string;
  tabKey: string;
  approvalStatus: LeadCreditStatusEnum;
  actions: boolean;
  savedFilters: ITableFilters;
  setSavedFilters: (data: ITableFilters) => void;
}

interface Filters {
  procurementType: string;
  vendor: string[];
  productType: string;
  model: string;
  color: string;
  date: string;
  brand: string;
}

const fields = [
  {
    label: 'Procurement Type',
    value: 'procurementType',
    options: [
      { label: 'Option 1', value: 'option1' },
      { label: 'Option 2', value: 'option2' },
    ],
    placeholder: 'Search Procurement Type',
  },
  {
    label: 'Vendor',
    value: 'vendor',
    options: [
      { label: 'Vendor 1', value: 'Vendor 1' },
      { label: 'Vendor 2', value: 'Vendor 2' },
    ],
    placeholder: 'Search Vendors',
    mode: 'multiple',
  },
  // More fields...
];

export const Review = ({ showRepeated, activeTab, tabKey, approvalStatus, actions, setSavedFilters, savedFilters }: ICreditLeadsProps) => {
  const { date } = useLeadContext();
  const [isPlanModalVisible, setIsPlanModalVisible] = useState('');
  const [holdModal, setHoldModal] = useState('');
  const [modalType, setModalType] = useState<'hold' | 'accept' | 'reject'>('hold');
  const [procurementsData, setProcurementsData] = useState<IItemsWithCount<IProcurementEntity>>(EMPTY_INITIAL_ITEMS);

  // const [isFetching, setIsFetching] = useState<boolean>(false);

  const [messageApi, contextHolder] = message.useMessage();
  const [leadModalVisible, setLeadModalVisible] = useState<boolean>(false);
  const [visible, setVisible] = useState(false);
  const [isMoveInventoryModalVisible, setIsMoveInventoryModalVisible] = useState(false);
  const [isViewReportModalVisible, setisViewReportModalVisible] = useState(false);
  const [isProcurementDetialModalVisible, setIsProcurementDetialModalVisible] = useState(false);
  const [isReportModalVisible, setReportModalVisible] = useState(false);
  const [reportData, setReportData] = useState<any[]>([]);


  const [filters, setFilters] = useState<Filters>({
    procurementType: '',
    vendor: [],
    productType: '',
    model: '',
    color: '',
    date: '',
    brand: ''
  });
  const [selectedVendors, setSelectedVendors] = useState<string[]>([]);


  const { refetch, isFetching } = useQuery<IItemsWithCount<IProcurementEntity>, AxiosError>({
    ...BASE_QUERY_OPTIONS,
    queryKey: ['procurements'],
    queryFn: () => GetTableItems<IProcurementEntity>(
      'procurement',
      ['vendor', 'products','products.brand', 'agent','products.product_type','comments'],
      [],
      tableState
    ),
    onSuccess: (returnedResult: IItemsWithCount<IProcurementEntity>): void => setProcurementsData({
      ...returnedResult,
      items: returnedResult.items.filter(item => item.approved === null),
    }),
    onError: (err) => setProcurementsData(EMPTY_INITIAL_ITEMS)
  });

  const [tableState, setTableState] = useState<ITableState>({
    ...DEFAULT_TABLE_STATE,
    sortBy: { created_at: 'DESC' },
  });

  const [selectedProcurement, setSelectedProcurement] = useState<IProcurementEntity | null>(null);
  const [editingLeadId, setEditingLeadId] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [actionType, setActionType] = useState<'approve' | 'reject' | null>(null);
  const [selectedItem, setSelectedItem] = useState<IFilterItemProps['item'] | null>(null);

  const [note, setNote] = useState('');


  // const refetch = useCallback(
  //   async (tableStateParams: ITableState, searchParams?: string, qyeryFilter?: string) => {
  //     setIsFetching(true);
  //     try {
  //       const query = `filter=credit.id,nnl,true;credit.approvalStatus,eq,${approvalStatus};credit.holdApprovalStatus,eq,false;drop_of,eq,false${
  //         approvalStatus === 'Pending' ? `;is_repeated,eq,${showRepeated || false}` : ''
  //       }${searchParams || ''}${qyeryFilter || ''}`;
  //       const returnedResult: IItemsWithCount<ILeadEntity> = await GetTableItems<ILeadEntity>(`lead?${query}`, ['product_type', 'channel', 'brand'], [], tableStateParams);
  //       setLeadsData(returnedResult);
  //     } catch (error) {
  //       setLeadsData(EMPTY_INITIAL_ITEMS);
  //     } finally {
  //       setIsFetching(false);
  //     }
  //   },
  //   [approvalStatus, date.startDate, date.endDate]
  // );



  const handleChange: TableProps<IProcurementEntity>['onChange'] = (pagination, filters, sorter) => {
    let sortBy: KeyValueRecord = RemoveUndefinedKeyPairs({
      [(sorter as SorterResult<ILeadEntity>).columnKey as keyof ILeadEntity]: MapAntDesignSortOrder((sorter as SorterResult<ILeadEntity>).order),
    });

    sortBy = Object.keys(sortBy).length ? sortBy : DEFAULT_TABLE_STATE.sortBy;

    setTableState({
      ...tableState,
      page: pagination.current || tableState.page,
      pageSize: pagination.pageSize || tableState.pageSize,
      sortBy: sortBy,
      search: MapAntDesignSearchFilter(RemoveUndefinedKeyPairs(filters)),
    });
  };

  // const getLastComment = (item: IProcurementEntity) => {
  //   return item.comments?.[0]?.text;
  // };

  const ActionModal: React.FC<IFilterItemProps> = ({ children, item }: IFilterItemProps) => {
    const [messageApi, contextHolder] = message.useMessage();

    const handleApprove = async () => {
      try {
        await PutItem('procurement/approve', item.id, {
          comment: 'Approved by admin',
          approve: true,
        });
        messageApi.success('Procurement approved successfully');
      } catch (error) {
        messageApi.error('Failed to approve procurement');
      }
    };

    const handleReject = async () => {
      try {
        await PutItem('procurement/approve', item.id, {
          comment: 'Rejected due to policy',
          approve: false,
        });
        messageApi.success('Procurement rejected successfully');
      } catch (error) {
        messageApi.error('Failed to reject procurement');
      }
    };

    const openModalForAction = (type: 'approve' | 'reject', item: IFilterItemProps['item']) => {
      setActionType(type);
      setNote('');
      setSelectedItem(item);
      setIsModalVisible(true);
    };



    const items: MenuProps['items'] = [
      {
        label: (
          <div onClick={() => openModalForAction('approve', item)} className="flex items-center gap-2">
            <CheckSquareOutlined className="w-[20px] h-[20px]" />
            <TextTypography fontSize={14}>Approve</TextTypography>
          </div>
        ),
        key: 'approve',
      },
      {
        label: (
          <div
            onClick={() => {
              setSelectedProcurement(item);
              openProcurementDetailsModal();
            }}
            className="flex items-center gap-2"
          >
            <EyeOutlined className="w-[20px] h-[20px]" />
            <TextTypography fontSize={14}>View Procurement Details</TextTypography>
          </div>
        ),
        key: 'view',
      },
      {
        label: (
          <div onClick={() => openModalForAction('reject', item)} className="flex items-center gap-2">
            <DislikeOutlined className="w-[20px] h-[20px]" />
            <TextTypography fontSize={14}>Decline</TextTypography>
          </div>
        ),
        key: 'reject',
      },
    ];

    return (
      <>
        {contextHolder}
        <Dropdown menu={{ items }} trigger={['click']} placement="topLeft">
          <a onClick={(e) => e.preventDefault()}>
            <Space wrap direction="vertical">
              {children}
            </Space>
          </a>
        </Dropdown>
      </>
    );
  };



  const columns: ColumnsType<IProcurementEntity> = [
    {
      title: 'Procurement ID',
      dataIndex: 'id',
      key: 'id',
      ellipsis: true,
      sorter: () => 0,
      sortDirections: ['ascend', 'descend'],
      render: (_: string) => (
        <Tooltip title={_}>
          <TextTypography
            fontSize={16}
            classNames="cursor-pointer flex h-[40px] items-center w-[134px] whitespace-nowrap overflow-hidden text-ellipsis">
            {_}
          </TextTypography>
        </Tooltip>
      ),
    },
    {
      title: 'Vendor Name',
      dataIndex: ['vendor', 'vendor_name'],
      key: 'vendor.vendor_name',
      ellipsis: true,
      sorter: () => 0,
      sortDirections: ['ascend', 'descend'],
      render: (_: string, item: IProcurementEntity) => {
        const name = item.vendor?.first_name;

        return (
          <Tooltip title={name}>
            <TextTypography
              fontSize={16}
              classNames="cursor-pointer truncate flex h-[40px] items-center w-[120px] whitespace-nowrap overflow-hidden text-ellipsis">
              {name}
            </TextTypography>
          </Tooltip>
        );
      },
    },
    {
      title: 'Agent',
      dataIndex: ['agent', 'first_name'],
      key: 'agent.first_name',
      ellipsis: true,
      sorter: () => 0,
      sortDirections: ['ascend', 'descend'],
      render: (_: string, item: IProcurementEntity) => {
        const name = item.agent?.first_name;

        return (
          <Tooltip title={name}>
            <TextTypography
              fontSize={16}
              classNames="cursor-pointer truncate flex h-[40px] items-center w-[120px] whitespace-nowrap overflow-hidden text-ellipsis">
              {name}
            </TextTypography>
          </Tooltip>
        );
      },
    },
    {
      title: 'Procurement Type',
      dataIndex: 'procurement_type',
      key: 'procurement_type',
      ellipsis: true,
      sorter: () => 0,
      sortDirections: ['ascend', 'descend'],
      render: (_: string, item: IProcurementEntity) => {
        const name = item.procurement_type;

        return (
          <Tooltip title={name}>
            <TextTypography
              fontSize={16}
              classNames="cursor-pointer truncate flex h-[40px] items-center w-[120px] whitespace-nowrap overflow-hidden text-ellipsis">
              {name}
            </TextTypography>
          </Tooltip>
        );
      },
    },
    {
      title: 'Product Type',
      dataIndex: ['products', 'product_type', 'name'],
      key: 'products.product_type_id',
      ellipsis: true,
      sorter: () => 0,
      sortDirections: ['ascend', 'descend'],
      render: (_: string, item: any) => {
        const name = item.products?.[0]?.product_type?.name || 'N/A';

        return (
          <Tooltip title={name}>
            <TextTypography
              fontSize={16}
              classNames="cursor-pointer truncate flex h-[40px] items-center w-[120px] whitespace-nowrap overflow-hidden text-ellipsis"
            >
              {name}
            </TextTypography>
          </Tooltip>
        );
      },
    },

    // {
    //   title: 'Procurement Status',
    //   dataIndex: 'procurement_status',
    //   key: 'procurement_status',
    //   ellipsis: true,
    //   sorter: () => 0,
    //   sortDirections: ['ascend', 'descend'],
    //   render: (_: string, item: IProcurementEntity) => {
    //     // const name = item.procurement_status;
    //     const name = '';
    //
    //     return (
    //       <Tooltip title={name}>
    //         <TextTypography
    //           fontSize={16}
    //           classNames="cursor-pointer truncate flex h-[40px] items-center w-[120px] whitespace-nowrap overflow-hidden text-ellipsis">
    //           {name}
    //         </TextTypography>
    //       </Tooltip>
    //     );
    //   },
    // },
    {
      title: 'Payment Method',
      dataIndex: 'payment_method',
      key: 'payment_method',
      ellipsis: true,
      sorter: () => 0,
      sortDirections: ['ascend', 'descend'],
      render: (_: string, item: IProcurementEntity) => {
        // const name = item.payment_method;
        const name = '';


        return (
          <Tooltip title={name}>
            <TextTypography
              fontSize={16}
              classNames="cursor-pointer truncate flex h-[40px] items-center w-[140px] whitespace-nowrap overflow-hidden text-ellipsis">
              {name}
            </TextTypography>
          </Tooltip>
        );
      },
    },
    {
      title: 'Paid',
      key: 'paid',
      ellipsis: true,
      sorter: () => 0,
      render: (_: string, item: IProcurementEntity) => {
        const paid = item?.paid?.toString();

        return (
          <Tooltip>
            <TextTypography
              fontSize={16}
              classNames="cursor-pointer truncate flex h-[40px] items-center w-[120px] whitespace-nowrap overflow-hidden text-ellipsis">
              {paid}
            </TextTypography>
          </Tooltip>
        );
      },
    },
    {
      title: 'Actions',
      dataIndex: 'operation',
      align: 'right',
      fixed: 'right',
      key: 'operation',
      render: (_: string, item: IProcurementEntity) => (
        <div className="w-[60px] flex justify-end">
          <ActionModal item={item as IProcurementEntity}>
            <Button type="text" shape="circle" icon={<MoreIcon />} className="!text-end h-[40px] w-[20px]" />
          </ActionModal>
        </div>
      ),
    },
  ];

  const getData = useCallback(() => {
    refetch();
  }, [date.startDate, date.endDate]);

  useEffect(() => {
    if (activeTab === '1') getData();
  }, [activeTab, getData]);

  useEffect(() => {
    getData();
  }, [tableState, getData]);


  const openMoveInventoryModal = () => {
    setIsMoveInventoryModalVisible(true);
  };

  const openProcurementDetailsModal = () => {
    setIsProcurementDetialModalVisible(true);
  }

  const closeProcurementDetailsModal = () => {
    setIsProcurementDetialModalVisible(false);

  }


  return (
    <>
      {contextHolder}
      <div className="border-2 border-black rounded-lg">
        <Table
          columns={columns}
          dataSource={procurementsData.items}
          onChange={handleChange}
          pagination={{
            total: procurementsData.count,
            pageSize: procurementsData.pageSize,
            current: procurementsData.page,
            size: 'default',
            className: 'ant-pagination-centered',
          }}
          loading={isFetching}
          rowKey={'id'}
          size="small"
          scroll={{ x: 'max-content' }}
        />
      </div>
      {isPlanModalVisible ? (
        <ViewPlanModal
          visible={isPlanModalVisible}
          onClose={() => {
            setIsPlanModalVisible('');
          }}
        />
      ) : null}
      {/*{holdModal ? (*/}
      {/*  <HoldModal*/}
      {/*    modalType={modalType}*/}
      {/*    visible={holdModal}*/}
      {/*    onClose={() => {*/}
      {/*      setHoldModal('');*/}
      {/*    }}*/}
      {/*    refetch={() => {*/}
      {/*      getData()(DEFAULT_TABLE_STATE);*/}
      {/*    }}*/}
      {/*  />*/}
      {/*) : null}*/}
      <ProcurementDetailsModal
        visible={isProcurementDetialModalVisible}
        onClose={closeProcurementDetailsModal}
        procurementDetails={selectedProcurement}
        openProcurementDetailsModal={openProcurementDetailsModal}
      />
      <Modal
        title={`${actionType === 'approve' ? 'Approve' : 'Reject'} Case`}
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsModalVisible(false)}>
            No, Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            danger={actionType === 'reject'}
            onClick={async () => {
              try {
                if (!selectedItem) return;
                await PutItem('procurement/approve', selectedItem.id, {
                  comment: note,
                  approve: actionType === 'approve',
                });
                messageApi.success(`Procurement ${actionType === 'approve' ? 'approved' : 'rejected'} successfully`);
              } catch (error) {
                messageApi.error(`Failed to ${actionType} procurement`);
              } finally {
                setIsModalVisible(false);
              }
            }}
            disabled={!note}
          >
            {actionType === 'approve' ? 'Yes, Approve' : 'Yes, Decline'}
          </Button>,
        ]}
      >
        <p>Please add a note before {actionType === 'approve' ? 'approving' : 'rejecting'} the case.</p>
        <TextArea
          rows={4}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Please Provide a Note"
        />
      </Modal>


    </>
  );
};
